import { createRouter, createWebHistory } from 'vue-router'

const BACKOFFICE_SESSION_KEY = 'redecor_bo_auth';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/', name: 'home', component: () => import('@/views/pages/home.vue'), meta: { layout: 'DefaultLayout' } },
        { path: '/services/:serviceName', component: () => import('@/views/pages/serviceDetail.vue'), props: true, meta: { layout: 'DefaultLayout' } },
        { path: '/products', name: 'products', component: () => import('@/views/pages/products.vue'), meta: { layout: 'DefaultLayout' } },
        { path: '/portfolio', name: 'portfolio', component: () => import('@/views/pages/gallery.vue'), meta: { layout: 'DefaultLayout' } },
        { path: '/contacts', name: 'contacts', component: () => import('@/views/pages/contacts.vue'), meta: { layout: 'DefaultLayout' } },
        { path: '/redecor', name: 'redecor', component: () => import('@/views/pages/redecor.vue'), meta: { layout: 'DefaultLayout' } },
        { path: '/history', name: 'history', component: () => import('@/views/pages/history.vue'), meta: { layout: 'DefaultLayout' } },
        { path: '/policy', name: 'policy', component: () => import('@/views/pages/policy.vue'), meta: { layout: 'DefaultLayout' } },
        {
            path: '/backoffice',
            name: 'backoffice',
            component: () => import('@/views/pages/backoffice.vue'),
            meta: { layout: 'DefaultLayout', requiresAuth: true }
        },
    ],
    scrollBehavior() {
        return { top: 0 }
    },
});

// Backoffice auth guard — prompts for password on first access, stores in sessionStorage
router.beforeEach((to) => {
    if (!to.meta.requiresAuth) return true;

    const authenticated = sessionStorage.getItem(BACKOFFICE_SESSION_KEY) === 'true';
    if (authenticated) return true;

    const password = window.prompt('Backoffice — Introduza a palavra-passe:');
    if (password === null) return false; // user cancelled

    const correct = password === process.env.VUE_APP_BACKOFFICE_PASSWORD;
    if (correct) {
        sessionStorage.setItem(BACKOFFICE_SESSION_KEY, 'true');
        return true;
    }

    alert('Palavra-passe incorreta.');
    return false;
});

export default router
